import React from 'react';

import Button from 'common/components/Button';
import trans from 'common/tools/translations/trans';

import styles from './styles.module.scss';

type Props = {
  displayCloseButton?: boolean;
  msg?: string;
  onHide?: () => void;
  title?: string;
};

const NewsletterSubscribedMsg = ({
  displayCloseButton = false,
  msg = 'subscribed with success',
  onHide,
  title
}: Props) => (
  <div className={styles.moduleSubscribed}>
    {title ? (
      <div className={styles.moduleSubscribedTitle}>
        {trans('newsletter-modal.subscribed-title')}
      </div>
    ) : null}
    <p className={styles.moduleSubscribedMsg}>{msg}</p>
    {displayCloseButton ? (
      <Button
        theme="inverse"
        className="js-trigger-overlay-close"
        onClick={onHide}
      >
        {trans('newsletter-modal.subscribed-button')}
      </Button>
    ) : null}
  </div>
);

export default NewsletterSubscribedMsg;
